import { FsTournamentTeams } from "db/model/tournament/FsTournamentTeams";
import { TournamentTeams } from "model/Tournament/TournamentTeams";
import { mapMultiple } from "../Utility";
import {
  mapTournamentDriverRoster,
  mapTournamentSquadRoster,
} from "./FsTournamentRoster";
import { DRIVER_SCOPE, SQUAD_SCOPE } from "model/Roster/RosterScope";

export const mapTournamentTeams = (
  fsModel: FsTournamentTeams
): TournamentTeams | undefined => {
  if (fsModel.scope === DRIVER_SCOPE) {
    return {
      scope: fsModel.scope,
      rosters: mapMultiple(fsModel.rosters, mapTournamentDriverRoster) ?? [],
    };
  }

  if (fsModel.scope === SQUAD_SCOPE) {
    return {
      scope: fsModel.scope,
      rosters: mapMultiple(fsModel.rosters, mapTournamentSquadRoster) ?? [],
    };
  }

  return undefined;
};
